import {
  Component,
  AfterContentChecked,
  ChangeDetectorRef,
} from '@angular/core';
import { ApiService } from '@core/services/api.service';

@Component({
  selector: 'kmt-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements AfterContentChecked {
  title = 'ng-kmt';
  languageCode = 'ENG';

  constructor(private cdr: ChangeDetectorRef, public apiService: ApiService) {}

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
}
